import { computed, defineComponent } from 'vue';
import classNames from '../_util/classNames';
import useConfigInject from '../config-provider/hooks/useConfigInject';
import Element, { skeletonElementProps } from './Element';
import omit from '../_util/omit';
import useStyle from './style';
const SkeletonInput = defineComponent({
    compatConfig: { MODE: 3 },
    name: 'ASkeletonInput',
    props: Object.assign(Object.assign({}, omit(skeletonElementProps(), ['shape'])), { size: String, block: Boolean }),
    setup(props) {
        const { prefixCls } = useConfigInject('skeleton', props);
        const [wrapSSR, hashId] = useStyle(prefixCls);
        const cls = computed(() => classNames(prefixCls.value, `${prefixCls.value}-element`, {
            [`${prefixCls.value}-active`]: props.active,
            [`${prefixCls.value}-block`]: props.block,
        }, hashId.value));
        return () => {
            return wrapSSR(<div class={cls.value}>
          <Element {...props} prefixCls={`${prefixCls.value}-input`}/>
        </div>);
        };
    },
});
export default SkeletonInput;
